import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';


// Redux slices
import { setSubPage, setSubPage2 } from '../menu/menuSlice';
import { setUserId, setActiveSection } from './settingsSlice';

// Components
import Max2SettingsAllotmentsLog from './allotments';
import Max2SettingsSystemData from './systemdata';
import Max2SettingsUsers from './users';
import Max2SettingsUserDetails from './userDetails';

// SemanticUI components
import { Segment, Label, Icon, Header, HeaderContent, Grid } from 'semantic-ui-react'

// Style
import './settings.css';




/**
 * 
 * @returns 
 */
const Max2Settings = () => {
  // local state
  const userId  = useSelector((state) => state.settings.userId);
  
  // global state
  const dispatch = useDispatch();
  const activeSection = useSelector((state) => state.settings.activeSection);
  
  // Translation
  const { t } = useTranslation();

  // Section Users
  if (activeSection === 'Users') {
    if (userId) {
      return <Max2SettingsUserDetails userId={userId} />
    }
    return (
      <Segment textAlign='left' style={{margin: '25px'}}>
        <Label circular style={{marginBottom: '20px'}}><span style={{fontSize: '1.4em', margin: '10px'}}>{t('settings.sections.users.title')}</span></Label>
        <div style={{position: 'absolute', top: '5px', right: '5px'}}>
          <Icon link size='large' name='times' onClick={() => { dispatch(setActiveSection(null)); dispatch(setSubPage(null)); dispatch(setUserId(null)) }} />
        </div>
        <Max2SettingsUsers />
      </Segment>
    )
  }

  // Section System Data
  if (activeSection === 'SystemData') {
    return (
      <Segment textAlign='left' style={{margin: '25px'}}>
        <Label circular style={{marginBottom: '20px'}}><span style={{fontSize: '1.4em', margin: '10px'}}>{t('settings.sections.systemData.title')}</span></Label>
        <div style={{position: 'absolute', top: '5px', right: '5px'}}>
          <Icon link size='large' name='times' onClick={() => { dispatch(setActiveSection(null)); dispatch(setSubPage(null)); dispatch(setSubPage2(null)) }} />
        </div>
        <Max2SettingsSystemData />
      </Segment>
    )
  }

  // Section Exports
  if (activeSection === 'Exports') {
    return (
      <Segment textAlign='left' style={{margin: '25px'}}>
        <Label circular style={{marginBottom: '20px'}}><span style={{fontSize: '1.4em', margin: '10px'}}>{t('settings.sections.exports.title')}</span></Label>
        <div style={{position: 'absolute', top: '5px', right: '5px'}}>
          <Icon link size='large' name='times' onClick={() => { dispatch(setActiveSection(null)); dispatch(setSubPage(null)) }} />
        </div>
      </Segment>
    )
  }

  // Section Allotments
  if (activeSection === 'Allotments') {
    return (
      <Segment textAlign='left' style={{margin: '25px'}}>
        <Label circular style={{marginBottom: '20px'}}><span style={{fontSize: '1.4em', margin: '10px'}}>{t('settings.sections.allotments.title')}</span></Label>
        <div style={{position: 'absolute', top: '5px', right: '5px'}}>
          <Icon link size='large' name='times' onClick={() => { dispatch(setActiveSection(null)); dispatch(setSubPage(null)) }} />
        </div>
        <Max2SettingsAllotmentsLog />
      </Segment>
    );
  }

  return (
    <Segment textAlign='left' style={{margin: '25px', padding:'150px 50px 150px 50px'}}>
      <Grid>
        <Grid.Column width={4}>
          <Header as='h2' icon textAlign='center' style={{cursor: 'pointer'}}>
            <Icon name='users' circular onClick={() => { dispatch(setActiveSection('Users')); dispatch(setSubPage(t('settings.sections.users.breadcrumb'))); }} />
            <HeaderContent>{t('settings.sections.users.title')}</HeaderContent>
          </Header>
        </Grid.Column>
        <Grid.Column width={4}>
          <Header as='h2' icon textAlign='center' style={{cursor: 'pointer'}}>
            <Icon name='settings' circular onClick={() => { dispatch(setActiveSection('SystemData')); dispatch(setSubPage(t('settings.sections.systemData.breadcrumb'))); }} />
            <HeaderContent>{t('settings.sections.systemData.title')}</HeaderContent>
          </Header>
        </Grid.Column>
        <Grid.Column width={4}>
          <Header as='h2' icon textAlign='center' style={{cursor: 'pointer'}}>
            <Icon name='download' circular onClick={() => { dispatch(setActiveSection('Exports')); dispatch(setSubPage(t('settings.sections.exports.breadcrumb'))); }} />
            <HeaderContent>{t('settings.sections.exports.title')}</HeaderContent>
          </Header>
        </Grid.Column>
        <Grid.Column width={4}>
          <Header as='h2' icon textAlign='center' style={{cursor: 'pointer'}}>
            <Icon name='history' circular onClick={() => { dispatch(setActiveSection('Allotments')); dispatch(setSubPage(t('settings.sections.allotments.breadcrumb'))); }} />
            <HeaderContent>{t('settings.sections.allotments.title')}</HeaderContent>
          </Header>
        </Grid.Column>
      </Grid>
    </Segment>
  )
}

export default Max2Settings;
